// import lazyLoading from '../lazyLoading';

export default {
  name: 'nlp_phrase',
  caption: 'Nlp İfade',
  wdm16_id: '',
  icon: 'icon-cursor',
  path: '/nlp_phrase',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
